'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  height: 30px;\n  min-width: 100px;\n  text-align: center;\n  margin-right: auto;\n  margin-left: auto;\n  cursor: pointer;\n  border-radius: 5px;\n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n  -o-transition: all 0.5s;\n  transition: all 0.5s;\n  position: relative;\n  line-height: 27px;\n\n  ', '\n\n  a {\n    color: rgba(51,51,51,1);\n    text-decoration: none;\n    display: block;\n  }\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0%;\n    height: 100%;\n    z-index: 1;\n    opacity: 0;\n    -webkit-transition: all 0.3s;\n    -moz-transition: all 0.3s;\n    -o-transition: all 0.3s;\n    transition: all 0.3s;\n    border-radius: 5px;\n  }\n\n  &:hover::before {\n    opacity: 1;\n    width: 100%;\n  }\n'], ['\n  height: 30px;\n  min-width: 100px;\n  text-align: center;\n  margin-right: auto;\n  margin-left: auto;\n  cursor: pointer;\n  border-radius: 5px;\n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n  -o-transition: all 0.5s;\n  transition: all 0.5s;\n  position: relative;\n  line-height: 27px;\n\n  ', '\n\n  a {\n    color: rgba(51,51,51,1);\n    text-decoration: none;\n    display: block;\n  }\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0%;\n    height: 100%;\n    z-index: 1;\n    opacity: 0;\n    -webkit-transition: all 0.3s;\n    -moz-transition: all 0.3s;\n    -o-transition: all 0.3s;\n    transition: all 0.3s;\n    border-radius: 5px;\n  }\n\n  &:hover::before {\n    opacity: 1;\n    width: 100%;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  z-index: 1;\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  line-height: 27px;\n'], ['\n  z-index: 1;\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  line-height: 27px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 23px;\n  height: 23px;\n  line-height: 23px;\n  margin-right: -5px;\n  background: ', ';\n  color: ', ';\n  border-radius: 100%;\n  margin-top: -11px;\n  float: right;\n'], ['\n  width: 23px;\n  height: 23px;\n  line-height: 23px;\n  margin-right: -5px;\n  background: ', ';\n  color: ', ';\n  border-radius: 100%;\n  margin-top: -11px;\n  float: right;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  height: 30px;\n  min-width: 100px;\n  margin-right: auto;\n  margin-left: auto;\n  cursor: pointer;\n  color: ', ';\n  display: inline-flex;\n  justify-content: flex-end;\n\n  span {\n    border: 1px solid ', ';\n    border-radius: 100%;\n    padding: 8px;\n\n    &:hover {\n      color: ', ';\n      background: ', ';\n      border: none;\n    }\n  }\n'], ['\n  height: 30px;\n  min-width: 100px;\n  margin-right: auto;\n  margin-left: auto;\n  cursor: pointer;\n  color: ', ';\n  display: inline-flex;\n  justify-content: flex-end;\n\n  span {\n    border: 1px solid ', ';\n    border-radius: 100%;\n    padding: 8px;\n\n    &:hover {\n      color: ', ';\n      background: ', ';\n      border: none;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = _styledComponents2.default.div(_templateObject, function (props) {
  var isDisabled = props.disabled === true;
  var isEnabledHasBackground = !isDisabled && props.background === true;
  var isEnabledNoBackground = !isEnabledHasBackground;
  if (isDisabled) {
    return '\n        color: ' + _color2.default.grey_accent_1 + ';\n        background: ' + _color2.default.purple_accent + ';\n      ';
  }
  if (isEnabledHasBackground) {
    return '\n        color: ' + _color2.default.white + ';\n        background-color: ' + _color2.default.blue_accent + ';\n        border: 1px solid ' + _color2.default.blue_accent + ';\n        border-radius: 5px;\n\n        &::before {\n          background-color: ' + _color2.default.blue_main + ';\n        }\n        &:hover {\n          color: ' + _color2.default.white + ';\n        }';
  }
  if (isEnabledNoBackground) {
    return '\n        color: ' + _color2.default.grey_main + ';\n        border: 1px solid ' + _color2.default.blue_accent + ';\n        border-radius: 5px;\n\n        &::before {\n          background: ' + _color2.default.blue_accent + ';\n          color: ' + _color2.default.white + ';\n          border: 1px solid ' + _color2.default.blue_accent + ';\n        }\n        &:hover {\n          color: ' + _color2.default.white + ';\n          background: ' + _color2.default.blue_accent + ';\n        }';
  }
});

var ButtonContent = _styledComponents2.default.div(_templateObject2);

var Indicator = _styledComponents2.default.div(_templateObject3, _color2.default.r34, _color2.default.white);

var IconButton = _styledComponents2.default.div(_templateObject4, _color2.default.blue_accent, _color2.default.grey_accent_1, _color2.default.white, _color2.default.blue_accent);

var MozartButton = function (_Component) {
  _inherits(MozartButton, _Component);

  function MozartButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MozartButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MozartButton.__proto__ || Object.getPrototypeOf(MozartButton)).call.apply(_ref, [this].concat(args))), _this), _this.throttleHandler = function () {
      return (0, _utils.throttle)(_this.onClickHandler, 3000);
    }, _this.onClickHandler = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;

      if (onClick && !disabled) {
        onClick();
      }
    }, _this.getButton = function () {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          testId = _this$props2.testId,
          themeId = _this$props2.themeId,
          indicator = _this$props2.indicator,
          icon = _this$props2.icon;

      var style_ = _this.getBackgroundColor();
      return icon ? _react2.default.createElement(
        IconButton,
        _extends({ 'data-qa': testId }, _this.props, { onClick: _this.throttleHandler(), style: style_, 'data-theme': themeId }),
        _react2.default.createElement(
          'p',
          { style: { margin: '0px', padding: '5px 10px 0px 0px' } },
          data
        ),
        icon
      ) : _react2.default.createElement(
        Button,
        _extends({ 'data-qa': testId, 'data-theme': themeId }, _this.props, { onClick: _this.throttleHandler(), style: style_ }),
        _react2.default.createElement(
          ButtonContent,
          null,
          data,
          indicator && _react2.default.createElement(
            Indicator,
            null,
            indicator
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MozartButton, [{
    key: 'getBackgroundColor',
    value: function getBackgroundColor() {
      var _props = this.props,
          style = _props.style,
          background = _props.background;

      var styleBG = Object.assign({}, style);
      styleBG.color = this.props.color;
      styleBG.background = _color2.default[background] ? _color2.default[background] : background;
      return styleBG;
    }
  }, {
    key: 'render',
    value: function render() {
      return this.getButton();
    }
  }]);

  return MozartButton;
}(_react.Component);

MozartButton.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** color of the label */
  color: _propTypes2.default.string,
  /** if true background color will be purple, otherwise can take string as mozart color. Example: 'orange_main' */
  background: _propTypes2.default.oneOf([_propTypes2.default.bool, _propTypes2.default.string]),
  /** disabled button */
  disabled: _propTypes2.default.bool,
  /** callback when click */
  onClick: _propTypes2.default.func,
  /** button label */
  data: _propTypes2.default.oneOf([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number]),
  /** indicator */
  indicator: _propTypes2.default.oneOf([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number]),
  /** icon if this used button will be no border no background icon on the right with data label on the left */
  icon: _propTypes2.default.node
};
MozartButton.defaultProps = {
  style: {},
  disabled: false,
  data: 'Ok',
  testId: 'MozartButton',
  themeId: 'MozartButton'
};
exports.default = MozartButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartButton/MozartButton.js
// module id = 309
// module chunks = 1